import { createSelector } from 'reselect';
import { get } from 'lodash';
import { MOET_CONSTANTS } from 'moet-core';
import { translator } from 'mage-i18n';

import { getFrontendTypeFromQueryParam } from '../widget';

import { merchantNameSpace } from './common';

const { WIDGET_TYPE } = MOET_CONSTANTS;

export const getRecollectionData = createSelector(
  merchantNameSpace,
  ({ recollection = {} }) => recollection,
);

export const getStakeholders = createSelector(
  getRecollectionData,
  ({ stakeholders = [] }) => stakeholders,
);

export const getSummaryStakeholders = createSelector(
  getRecollectionData,
  translator,
  ({ stakeholders = [] }, t) =>
    stakeholders.map(stakeholder => {
      const country = get(stakeholder, 'data.address.country', '');
      return {
        ...stakeholder,
        data: {
          ...stakeholder.data,
          address: {
            ...stakeholder.data.address,
            country: t(`products-fe.countries.${country}`, {}, country),
            countryKey: country,
          },
        },
      };
    }),
);

export const isRecollectionMerchant = createSelector(
  getFrontendTypeFromQueryParam,
  widgetType => widgetType === WIDGET_TYPE.RECOLLECTION_KYC,
);

export const isRecollectionInitialized = createSelector(
  getRecollectionData,
  ({ isInitialized = false }) => isInitialized,
);
